import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CourseHeader from 'experienceComponents/CourseHeader'
import CourseInstanceCard from 'experienceComponents/CourseInstanceCard'
import LearnErrorBoundary from 'components/LearnErrorBoundary'

export default class CourseComponent extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.object,
      PropTypes.string,
    ]),
    createdDate: PropTypes.string,
    displayTitle: PropTypes.string,
    entryId: PropTypes.string,
    forwardedRef: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
    ]),
    instance: PropTypes.string,
    isEditable: PropTypes.bool,
    listView: PropTypes.bool,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    scoId: PropTypes.number,
    scopeAndSequenceDisplayTitle: PropTypes.string,
    scopeAndSequenceUrl: PropTypes.string,
    selectCourseInstance: PropTypes.func,
    setFocus: PropTypes.func,
    skipHead: PropTypes.bool,
    title: PropTypes.string,
    totalAmount: PropTypes.number,
    totalComplete: PropTypes.number,
  }

  handleSelectCourseInstance = () => {
    const { props } = this
    if (!props.selectCourseInstance) return null
    return props.selectCourseInstance(props.instance)
  }

  parseGradeText = gradeText => {
    if (!gradeText) {
      return ''
    }
    return gradeText === 'Kindergarten' ? 'K' : gradeText.slice(6, 7)
  }

  render() {
    const {
      children,
      createdDate,
      displayTitle,
      isEditable,
      listView,
      onBlur,
      onFocus,
      title,
      scoId,
      scopeAndSequenceUrl,
      scopeAndSequenceDisplayTitle,
      setFocus,
      totalAmount,
      totalComplete,
      instance,
      skipHead,
    } = this.props

    const gradeNumber = this.parseGradeText(displayTitle)
    const lessonsAmounts = [{ totalAmount, totalComplete }]
    const scopeAndSequenceLinks = [
      {
        linkHref: scopeAndSequenceUrl,
        linkLabel: scopeAndSequenceDisplayTitle,
      },
    ]

    return (
      <LearnErrorBoundary>
        {listView && (
          <CourseInstanceCard
            course={this.props}
            courseInstanceName={title}
            createdDate={createdDate}
            gradeNumber={gradeNumber}
            gradeTitle={title}
            isEditable={isEditable}
            key={`course-instance-${title}`}
            onBlur={onBlur}
            onFocus={onFocus}
            ref={this.props.forwardedRef}
            scoId={scoId}
            setFocus={setFocus}
            totalAmount={totalAmount}
            totalComplete={totalComplete}
            viewLessonsOnClick={this.handleSelectCourseInstance}
          />
        )}
        {!listView && (
          <CourseHeader
            dataTestId="course-instance-header"
            gradeNumber={gradeNumber}
            gradeTitle={title}
            isPreview={!instance}
            key={`course-instance-header-${title}`}
            lessonsAmounts={lessonsAmounts}
            scopeAndSequenceLinks={scopeAndSequenceLinks}
            skipHead={skipHead}
          />
        )}
        {children && children}
      </LearnErrorBoundary>
    )
  }
}
